import { selector } from "recoil"
import { getMyOrganizations, MyOrganization } from "src/queries/getMyOrganizations"
import {
  myFullOrganizationsRequestIdState,
  myOrganizationsRequestIdState,
} from "src/recoil/atoms/organization/myOrganizationsRequestIdState"
import { tokensState } from "src/recoil/atoms/authorization/tokensState"
import { ImageTeamModel, multiTeamImageGetUrl } from "src/apis/resource/getResourceGetUrl"
import { accountIdState } from "src/recoil/atoms/account/accoutnIdState"
import { accountSelector } from "src/recoil/selectors/account/accountSelector"
import { deviceTokenOptInBooleanState } from "src/recoil/atoms/account/deviceTokenOptInState"
import { deviceTokenState } from "src/recoil/atoms/account/deviceTokenState"
import { sendFirebasePropertiesIfNeeded } from "src/utils/firebasePropertiesHelper"

export const myOrganizationsSelector = selector<MyOrganization[]>({
  key: "selectors/organization/myOrganizationsSelector",
  get: async ({ get }) => {
    get(myOrganizationsRequestIdState)
    const tokens = get(tokensState)
    const accountId = get(accountIdState)
    if (tokens == null || accountId == null) return []

    const organizations = await getMyOrganizations({
      accessToken: tokens.accessToken,
      accountId,
    })

    // Firebase Analytics送信（初回起動時のみ）
    // 団体未所属でも属性を送信することで、セグメント機能が正しく動作する
    try {
      const account = get(accountSelector)
      const optIn = get(deviceTokenOptInBooleanState)
      const deviceToken = get(deviceTokenState)

      if (account) {
        await sendFirebasePropertiesIfNeeded(
          account,
          organizations, // 空配列でもOK（isManager="false", joinedFreeOrganization="false"として送信）
          optIn,
          deviceToken,
          false // 強制更新ではない
        )
      }
    } catch (error) {
      // Firebase送信エラーは無視（メイン処理に影響させない）
      console.error("[myOrganizationsSelector] Error sending Firebase properties:", error)
    }

    return organizations
  },
})

export const myFullOrganizationsSelector = selector<MyOrganization[]>({
  key: "selectors/organization/myFullOrganizationsSelector",
  get: async ({ get }) => {
    get(myFullOrganizationsRequestIdState)
    const tokens = get(tokensState)
    const accountId = get(accountIdState)
    if (tokens == null || accountId == null) return []

    const myOrganizations = await getMyOrganizations({
      accessToken: tokens.accessToken,
      accountId,
    })
    if (myOrganizations.length === 0) {
      return []
    }

    const teamImages = myOrganizations.map((el) => {
      const result = {
        teamId: el.id,
        thumbnail: false,
      }
      return result
    })

    if (teamImages.length === 0) {
      return []
    }

    const data = await multiTeamImageGetUrl({
      accessToken: tokens.accessToken,
      teamImages: teamImages,
    })
    if (!data) {
      return myOrganizations
    }

    return myOrganizations.map((el) => {
      const result = {
        id: el.id,
        title: el.title,
        uriImage: getTeamImageUrl(el.id, data),
        organizationNumber: el.organizationNumber,
        myMemberNumber: el.myMemberNumber,
        migrationId: el.migrationId,
        paidFunctionEnabled: el.paidFunctionEnabled ?? true,
        showAdsFlg: el.showAdsFlg ?? true,
      }
      return result
    })
  },
})

function getTeamImageUrl(organizationId: string, teamImagetUrls: ImageTeamModel[]) {
  const team = teamImagetUrls.find((el) => el.teamId === organizationId)
  return team?.url ?? undefined
}
